import api from "./api";

export const checkDomain = async () => {
    const response = await api.get("/api/v1/site/check-domain");
    return response;
 }